import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from "react-intl";

import { withStyles } from "@material-ui/core/styles";
import Spinner from "react-activity/lib/Spinner";
import { auth, cloudFunctions } from "../../firebase";
import {
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Checkbox
} from "../../../node_modules/@material-ui/core";
import AppContainer from "../AppContainer";

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  },
  textField: {
    flex: 1,
    marginTop: theme.spacing.unit,
    marginBottom: 0
  },
  button: {
    marginTop: theme.spacing.unit * 2
  }
});

const INITIAL_STATE = {
  firstName: "",
  phone: "",
  email: "",
  passwordOne: "",
  passwordTwo: "",
  hasReadToS: false,
  error: null,
  updating: false
};

class DetailerSignUpScreen extends Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
    classes: PropTypes.shape({}).isRequired,
    intl: PropTypes.shape({}).isRequired
  };

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    // event.preventDefault();
    const { firstName, phone, email, passwordOne, hasReadToS } = this.state;
    // const { history } = this.props;

    this.setState({ updating: true }, () => {
      auth
        .doCreateUserWithEmailAndPassword(email, passwordOne)
        .then(() => {
          cloudFunctions
            .initUser(email, firstName, phone, hasReadToS, true)
            .then(() => {
              // Start the Onboarding process
              cloudFunctions.stripeConnectStartOnboard().then(stripeURL => {
                //this.setState({ ...INITIAL_STATE, updating: false });
                // console.log("Stripe URL: " + stripeURL);
                window.location.assign(stripeURL);
              });
            })
            .catch(error => {
              this.setState({
                error: error,
                updating: false
              });
            });
        })
        .catch(error => {
          this.setState({ error: error, updating: false });
        });
    });

    // Don't refresh the page
    event.preventDefault();
  };

  byPropKey = (propertyName, value) => () => ({
    [propertyName]: value
  });

  translateMessage = messageID => {
    const { intl } = this.props;
    return intl.formatMessage({ id: messageID });
  };

  render() {
    const componentName = "DetailerSignUpScreen";
    const {
      firstName,
      phone,
      email,
      hasReadToS,
      passwordOne,
      passwordTwo,
      error,
      updating
    } = this.state;
    const { classes } = this.props;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === "" ||
      phone === "" ||
      email === "" ||
      firstName === "" ||
      hasReadToS === false;

    return (
      <AppContainer>
        <h1 style={{ paddingBottom: 0 }}>
          <FormattedMessage id={`${componentName}.Title`} />
        </h1>
        <div style={{ maxWidth: 700, margin: "0 auto", marginBottom: 100 }}>
          {updating ? (
            <div>
              <p style={{ textAlign: "center", marginBottom: 80 }}>
                <FormattedHTMLMessage id={`${componentName}.PleaseStandBy`} />
              </p>
              <Spinner size={40} color="#aaaaaa" />
            </div>
          ) : (
            <div>
              {error ? (
                <p className="errorBox">
                  <FormattedMessage id={`${componentName}.Error`} />
                  :&nbsp;
                  {error.message}
                </p>
              ) : null}
              <FormattedHTMLMessage id={`${componentName}.EnterDetails`} />

              <Grid container justify="center">
                <Grid
                  style={{
                    maxWidth: 400
                  }}
                >
                  <form onSubmit={this.onSubmit}>
                    <TextField
                      id="firstName"
                      label={this.translateMessage(
                        `${componentName}.FirstName`
                      )}
                      className={classes.textField}
                      value={firstName}
                      onChange={event =>
                        this.setState(
                          this.byPropKey("firstName", event.target.value)
                        )
                      }
                      margin="normal"
                      fullWidth
                    />

                    <TextField
                      id="email"
                      label={this.translateMessage(
                        `${componentName}.EmailAddress`
                      )}
                      className={classes.textField}
                      value={email}
                      onChange={event =>
                        this.setState(
                          this.byPropKey("email", event.target.value)
                        )
                      }
                      margin="normal"
                      fullWidth
                      type="email"
                    />

                    <TextField
                      id="phone"
                      label={this.translateMessage(
                        `${componentName}.CellPhone`
                      )}
                      className={classes.textField}
                      value={phone}
                      onChange={event =>
                        this.setState(
                          this.byPropKey("phone", event.target.value)
                        )
                      }
                      margin="normal"
                      fullWidth
                      type="phone"
                    />

                    <TextField
                      id="passwordOne"
                      label={this.translateMessage(`${componentName}.Password`)}
                      className={classes.textField}
                      value={passwordOne}
                      onChange={event =>
                        this.setState(
                          this.byPropKey("passwordOne", event.target.value)
                        )
                      }
                      margin="normal"
                      type="password"
                      fullWidth
                    />

                    <TextField
                      id="passwordTwo"
                      label={this.translateMessage(
                        `${componentName}.ConfirmPassword`
                      )}
                      className={classes.textField}
                      value={passwordTwo}
                      onChange={event =>
                        this.setState(
                          this.byPropKey("passwordTwo", event.target.value)
                        )
                      }
                      margin="normal"
                      type="password"
                      fullWidth
                    />

                    <FormControlLabel
                      control={(
                        <Checkbox
                          checked={hasReadToS}
                          onChange={event => {
                            this.setState(
                              this.byPropKey("hasReadToS", event.target.checked)
                            );
                          }}
                          value="hasReadToS"
                          color="primary"
                        />
)}
                      style={{ paddingTop: 25 }}
                      label={this.translateMessage(
                        `${componentName}.IHaveReadToU`
                      )}
                    />

                    <Button
                      disabled={isInvalid || updating}
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      fullWidth
                    >
                      <FormattedMessage id={`${componentName}.CreateAccount`} />
                    </Button>
                  </form>
                </Grid>
              </Grid>
            </div>
          )}
        </div>
      </AppContainer>
    );
  }
}

export default withStyles(styles)(withRouter(injectIntl(DetailerSignUpScreen)));



// WEBPACK FOOTER //
// ./src/screens/detailer/DetailerSignUpScreen.js